import { Button } from '@moniebook-web/components/atoms/button';
import { StructuredModal } from '@moniebook-web/components/atoms/structured-modal';
import { Body } from '@moniebook-web/components/atoms/typography';

interface EndGhostSessionModalProps {
    isOpen: boolean;
    businessName: string | undefined;
    isEnding: boolean;
    onClose: VoidFunction;
    onConfirm: VoidFunction;
}

export function EndGhostSessionModal({
    isOpen,
    businessName,
    isEnding,
    onClose,
    onConfirm,
}: Readonly<EndGhostSessionModalProps>) {
    return (
        <StructuredModal.Modal isOpen={isOpen} onClose={onClose}>
            <StructuredModal.Header className='flex flex-row justify-between'>
                <StructuredModal.Title className='font-general-sans! font-semibold!'>
                    End ghost session?
                </StructuredModal.Title>
                <StructuredModal.CloseButton
                    className='size-32! rounded-full!'
                    onClick={onClose}
                />
            </StructuredModal.Header>

            <StructuredModal.Body>
                <Body className='font-normal text-content-subtext-alternative'>
                    You're about to end your active ghost session on{' '}
                    {businessName}. You'll need to submit a new request for
                    further access.
                </Body>
            </StructuredModal.Body>

            <StructuredModal.Footer className='items-center gap-16'>
                <Button
                    label='Cancel'
                    onClick={onClose}
                    theme='secondary'
                    size='small'
                    disabled={isEnding}
                    className='flex-1'
                />
                <Button
                    label='End session'
                    onClick={onConfirm}
                    theme='danger'
                    size='small'
                    disabled={isEnding}
                    className='flex-1'
                />
            </StructuredModal.Footer>
        </StructuredModal.Modal>
    );
}
